import React, { Component, PropTypes } from 'react';

import Page from '../containers/Page';

export default class ErrorPage extends Component {
  static propTypes = {
    children: PropTypes.node,
    subtitle: PropTypes.string,
    title: PropTypes.string.isRequired,
  }

  render() {
    const {
      children,
      subtitle,
      title,
      ...rest,
    } = this.props;
    return (
      <Page {...rest}>
        <div className="tc">
          <div className="serif" style={{ marginTop: '6em' }}>
            <h1>{ title }</h1>
          </div>
          {subtitle &&
            <div className="mt3 f4">
              {subtitle}
            </div>
          }
          { children }
        </div>
      </Page>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ErrorPage.jsx
 **/